import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpResponse} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
import {filter} from 'rxjs/operators';
@Injectable({providedIn: 'root'})
export class AttachmentService extends BaseService {
  private url = 'api/attachment';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  /**
   * 文件删除
   * @param object
   * @returns {Observable<any|any>}
   */
  deleteFile(id:any):Observable<any> {
    const url = `${this.getUrl()}/${id}`;
    return this.http.delete<any>(url).pipe(
      tap(_ => this.log(`deleted file id=${id}`)),
      catchError(this.handleError<any>('deleteany'))
    );
  }

  /**
   * 文件上传
   * @param object
   * @returns {Observable<any|any>}
   */
  uploadFile(file:any):Observable<any> {
    const url = `api/file/upload`;
    return this.http.post<any>(url, file).pipe(
      tap(_ => this.log(`uploadFile`)),
      catchError(this.handleError<any>('uploadFile'))
    );
  }

  uploadFileAnyouse(file:any):Observable<any> {
    const url = `api/file/upload?_allow_anonymous=true`;
    return this.http.post<any>(url, file).pipe(
      tap(_ => this.log(`uploadFile`)),
      catchError(this.handleError<any>('uploadFile'))
    );
  }

  /**
   * 多文件上传
   * @param object
   * @returns {Observable<any|any>}
   */
  uploadFileMulti(files:FormData):Observable<any> {
    const url = `api/file/upload-multi`;
    return this.http.post<any>(url, files).pipe(
      tap(_ => this.log(`uploadFiles`)),
      catchError(this.handleError<any>('uploadFiles'))
    );
  }
}

